"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.styles = exports.POINTER_SIZE = void 0;
exports.POINTER_SIZE = 14;
const styles = (theme) => {
    const pointer = exports.POINTER_SIZE * 1.5;
    const qcardPositionBase = {
        content: "' '",
        width: 0,
        height: 0,
        border: `${exports.POINTER_SIZE}px solid transparent`,
        position: 'absolute',
        left: '100%',
        top: '50%',
        marginRight: -exports.POINTER_SIZE,
        marginTop: -exports.POINTER_SIZE,
    };
    return ({
        wrapperOff: {
            position: 'absolute',
        },
        qcardPositionBase,
        qcard: {
            willChange: 'top, left, width, height, opacity',
            transitionProperty: 'top, left, width, height',
            transitionDuration: '.4s',
            transitionTimingFunction: 'ease',
            position: 'fixed',
            top: 0,
            left: 0,
            width: 300,
            height: 100,
            background: theme.palette.cuecards.surface,
            zIndex: 1202,
            borderRadius: 5,
            boxShadow: `${theme.palette.border.shadow} 5px 5px 10px`,
            '&.left': {
                '&:after': Object.assign(Object.assign({}, qcardPositionBase), { borderLeft: `${exports.POINTER_SIZE}px solid ${theme.palette.cuecards.surface}` }),
            },
            '&.right': {
                '&:after': Object.assign(Object.assign({}, qcardPositionBase), { borderRight: `${exports.POINTER_SIZE}px solid ${theme.palette.cuecards.surface}`, right: '100%', left: 'unset', marginLeft: -exports.POINTER_SIZE, marginTop: -exports.POINTER_SIZE, marginRight: 'unset' }),
            },
            '&.righttop': {
                '&:after': Object.assign(Object.assign({}, qcardPositionBase), { borderRight: `${exports.POINTER_SIZE}px solid ${theme.palette.cuecards.surface}`, right: '100%', left: 'unset', top: pointer, marginRight: 'unset' }),
            },
            '&.rightbottom': {
                '&:after': Object.assign(Object.assign({}, qcardPositionBase), { borderRight: `${exports.POINTER_SIZE}px solid ${theme.palette.cuecards.surface}`, right: '100%', left: 'unset', top: 'unset', bottom: pointer, marginRight: 'unset' }),
            },
            '&.lefttop': {
                '&:after': Object.assign(Object.assign({}, qcardPositionBase), { borderLeft: `${exports.POINTER_SIZE}px solid ${theme.palette.cuecards.surface}`, top: pointer }),
            },
            '&.leftbottom': {
                '&:after': Object.assign(Object.assign({}, qcardPositionBase), { borderLeft: `${exports.POINTER_SIZE}px solid ${theme.palette.cuecards.surface}`, top: 'unset', bottom: pointer }),
            },
        },
        buttonArea: {
            position: 'absolute',
            bottom: 0,
            width: '100%',
            textAlign: 'center',
            padding: 5,
        },
        contentArea: {
            marginTop: 10,
            paddingLeft: 10,
            paddingRight: 10,
        },
        title: {
            color: theme.palette.cuecards.title,
            fontSize: 16,
            paddingRight: 20,
        },
        content: {
            marginTop: 10,
            color: theme.palette.cuecards.text,
            fontSize: theme.typography.fontSize,
        },
        closeBox: {
            position: 'absolute',
            right: 5,
            top: 5,
        },
        closeIcon: {
            color: theme.palette.cuecards.text,
        },
        buttonText: {
            color: theme.palette.cuecards.link,
        },
        highlight: {
            boxShadow: `${theme.palette.overlayScale.black60} 0px 0px 18px`,
        },
    });
};
exports.styles = styles;
